// add triple dots if the string is longer than the limit
export function compressString(str, limit) {
  if (str.length > limit) {
    return str.substring(0, limit) + '...';
  }
  return str;
}
